export const getValuesPropertyMap = (
  valueMap: { [key: string]: any | null } | any[],
  fieldNames: string[],
  getValueFunction?: (valueMap: any, fieldName: string) => string | null,
  getKeyFunction?: (fieldName: string) => string
) => {
  const values: { [key: string]: any | null } = {};
  fieldNames.forEach((fieldName, index) => {
    values[getKeyFunction ? getKeyFunction(fieldName) : fieldName] = getValueFunction
      ? getValueFunction(valueMap, fieldName)
      : valueMap[index];
  });
  return values;
};
